import i18n from '@/i18n'

// Standalone translate for non-component code — composables, utils, and any
// module that isn't a component <script setup>. Unlike useI18n(), which must
// run during setup(), this works anywhere: async callbacks, error handlers,
// module scope. It reads the app-wide reactive global locale, so a computed()
// that calls it re-evaluates on a language switch, and one-shot strings (error
// fallbacks, toasts) resolve in the current language at call time.
//
// In components use useI18n()/$t; reach for this only outside setup.
export const t = i18n.global.t.bind(i18n.global) as typeof i18n.global.t

// te(key) — does a message exist for this key? Used to decide whether a
// backend error code has a localized message before falling back to a
// generic one.
export const te = i18n.global.te.bind(i18n.global) as typeof i18n.global.te
